import { render, staticRenderFns } from "./ManagePromotionalCodes.vue?vue&type=template&id=06a3e7ae&"
import script from "./ManagePromotionalCodes.vue?vue&type=script&lang=js&"
export * from "./ManagePromotionalCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports